var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"length":_vm.total,"total-visible":7},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }